import { render, staticRenderFns } from "./GroupBuyActivityList.vue?vue&type=template&id=42441e54&scoped=true"
import script from "./GroupBuyActivityList.vue?vue&type=script&lang=js"
export * from "./GroupBuyActivityList.vue?vue&type=script&lang=js"
import style0 from "./GroupBuyActivityList.vue?vue&type=style&index=0&id=42441e54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42441e54",
  null
  
)

export default component.exports